import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Person, Public } from '@mui/icons-material';
import { COLOR } from '../ui/tokens';

export const SI_MODES = [
    { value: 'solo', label: 'Solo', icon: Person },
    { value: 'coop', label: 'Online Co-op', icon: Public },
];

/** Space Invader mode picker (Solo / Online Co-op); locked while a co-op room is live. */
export default function SpaceInvaderModePicker({ value, onChange, accentColor = COLOR.primary, disabled = false }) {
    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            value={value}
            aria-label="Game mode"
            data-testid="si-mode-picker"
            onChange={(_, v) => { if (v && v !== value) onChange(v); }}
        >
            {SI_MODES.map(({ value: mode, label, icon: Icon }) => (
                <ToggleButton
                    key={mode}
                    value={mode}
                    disabled={disabled && value !== mode}
                    sx={{
                        color: COLOR.textMuted,
                        textTransform: 'none',
                        gap: 0.75,
                        '&.Mui-selected': { color: COLOR.text, borderColor: accentColor },
                    }}
                >
                    <Icon fontSize="small" />
                    {label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
